export default "__VITE_PUBLIC_ASSET__13c597d7__"